export const formatDateTimeSelection = (date: Date, hours: number, minutes: number) => {
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const yyyy = date.getFullYear();

  const hh = String(hours).padStart(2, "0");
  const min = String(minutes).padStart(2, "0");

  return `${mm}/${dd}/${yyyy} - ${hh}:${min}`;
};
